export const localStorageKeys = {
    user: 'User',
    token: 'Token',
    navigation: 'Navigation',
    permission: 'Permission',
    systemLanguage: 'SystemLanguage'
}
